module.exports = __webpack_public_path__ + "img/pic_bg@2x.db91f9bd.png";